import {
    Input,
    OnDestroy,
} from '@angular/core';

import {
    BehaviorSubject,
    Observable,
    Subject,
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export abstract class JobTriggerBaseComponent<T> implements OnDestroy {

    @Input()
    public set itemId(value: number) {
        if (this._itemId !== value) {
            this._itemId = value;
            if (this._itemId) {
                this.loading$.next(true);
                this._fetchItem()
                    .pipe(
                        takeUntil(this._destroyed$),
                    )
                    .subscribe(data => {
                        this.item = data;
                        this.loading$.next(false);
                    });
            } else {
                this.item = undefined;
            }
        }
    }

    public get itemId() {
        return this._itemId;
    }

    public item?: T;
    public loading$ = new BehaviorSubject(false);

    protected _itemId = 0;
    private _destroyed$ = new Subject();

    ngOnDestroy() {
        this._destroyed$.next();
    }

    protected abstract _fetchItem(): Observable<T>;
}
